import { render, staticRenderFns } from "./tournamentBet.vue?vue&type=template&id=1cecbdd4"
import script from "./tournamentBet.vue?vue&type=script&lang=js"
export * from "./tournamentBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports